var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginexLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1067 54.4467L78.9467 36.38L19.2933 3.82001V36.38L49.1067 54.4467Z",
    fill: "url(#paint0_linear_970_38592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9467 72.5L108.773 54.4467L78.9467 36.38L49.1067 54.4467L78.9467 72.5Z",
    fill: "url(#paint1_linear_970_38592)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.773 54.4467V18.3L78.9467 36.38L108.773 54.4467Z",
    fill: "#83C117"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8933 72.2467L49.0533 90.3267L108.707 125.18V90.3267L78.8933 72.2467Z",
    fill: "url(#paint2_linear_970_38592)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0534 54.18L19.2267 72.2467L49.0534 90.3267L78.8933 72.2467L49.0534 54.18Z",
    fill: "url(#paint3_linear_970_38592)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2267 72.2467V108.393L49.0534 90.3267L19.2267 72.2467Z",
    fill: "#1C98EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_970_38592",
    x1: 21.56,
    y1: 26.2867,
    x2: 88.6533,
    y2: 41.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFB752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_970_38592",
    x1: 113.987,
    y1: 33.5667,
    x2: 65.52,
    y2: 62.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#83C117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#609E04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_970_38592",
    x1: 49.0533,
    y1: 98.7134,
    x2: 108.707,
    y2: 98.7134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF6B77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_970_38592",
    x1: 22.4134,
    y1: 72.2467,
    x2: 78.8933,
    y2: 72.2467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1C98EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0087E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginexLogo);
export default __webpack_public_path__ + "static/media/loginex-logo.f6c69a9f7e962eda2bc7e4f83f6db7b9.svg";
export { ForwardRef as ReactComponent };